<template>
  <div class="dialog" id="clear-shopping-list-dialog" aria-hidden="true">
    <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
    <div
      role="dialog"
      class="dialog-content"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-description"
    >
      <button
        data-a11y-dialog-hide
        class="dialog-close"
        aria-label="Close this dialog window"
      >
        <img
          src="@/assets/icons/dialog-close.svg"
          width="34"
          height="34"
          alt="Dialog close"
        />
      </button>

      <div class="delete-product">
        <h2 class="delete-product__title">
          {{ $t("list.list_delete_question") }}
        </h2>
        <div class="delete-product__button-group">
          <button class="delete-product__button" @click="onDelete">
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.55 3.3H1.46875C1.29139 3.3 1.12129 3.37046 0.995872 3.49587C0.870457 3.62129 0.8 3.79139 0.8 3.96875C0.8 4.14611 0.870457 4.31621 0.995872 4.44163C1.12129 4.56704 1.29139 4.6375 1.46875 4.6375H2.05V15.8438C2.05 16.1869 2.18631 16.5159 2.42893 16.7586C2.67156 17.0012 3.00063 17.1375 3.34375 17.1375H13.3438C13.6869 17.1375 14.0159 17.0012 14.2586 16.7586C14.5012 16.5159 14.6375 16.1869 14.6375 15.8438V4.6375H15.2188C15.3961 4.6375 15.5662 4.56704 15.6916 4.44163C15.817 4.31621 15.8875 4.14611 15.8875 3.96875C15.8875 3.79139 15.817 3.62129 15.6916 3.49587C15.5662 3.37046 15.3961 3.3 15.2188 3.3H12.1375L12.1375 2.71875L12.1375 2.71785C12.1352 2.20991 11.9324 1.72343 11.5732 1.36426C11.2141 1.00509 10.7276 0.802295 10.2197 0.8H10.2188L6.46875 0.799998L6.46785 0.800002C5.95991 0.802295 5.47343 1.00509 5.11426 1.36426C4.75509 1.72343 4.5523 2.20991 4.55 2.71785L4.55 2.71785V2.71875V3.3ZM5.8875 2.71875C5.8875 2.56459 5.94874 2.41675 6.05774 2.30774C6.16675 2.19874 6.31459 2.1375 6.46875 2.1375H10.2188C10.3729 2.1375 10.5208 2.19874 10.6298 2.30774C10.7388 2.41675 10.8 2.56459 10.8 2.71875V3.3H5.8875V2.71875ZM13.3 4.6375V15.8H3.3875V4.6375H13.3ZM7.1375 12.7188V7.71875C7.1375 7.54139 7.06704 7.37129 6.94163 7.24587C6.81621 7.12046 6.64611 7.05 6.46875 7.05C6.29139 7.05 6.12129 7.12046 5.99587 7.24587C5.87046 7.37129 5.8 7.54139 5.8 7.71875V12.7188C5.8 12.8961 5.87046 13.0662 5.99587 13.1916C6.12129 13.317 6.29139 13.3875 6.46875 13.3875C6.64611 13.3875 6.81621 13.317 6.94163 13.1916C7.06704 13.0662 7.1375 12.8961 7.1375 12.7188ZM10.8875 12.7188V7.71875C10.8875 7.54139 10.817 7.37129 10.6916 7.24587C10.5662 7.12046 10.3961 7.05 10.2188 7.05C10.0414 7.05 9.87129 7.12046 9.74587 7.24587C9.62046 7.37129 9.55 7.54139 9.55 7.71875V12.7188C9.55 12.8961 9.62046 13.0662 9.74587 13.1916C9.87129 13.317 10.0414 13.3875 10.2188 13.3875C10.3961 13.3875 10.5662 13.317 10.6916 13.1916C10.817 13.0662 10.8875 12.8961 10.8875 12.7188Z"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="0.4"
              />
            </svg>

            {{ $t("list.list_delete_long") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useShoppingListStore } from "@/stores/shoppingList.store";
const modal = ref();
onMounted(() => {
  modal.value = new A11yDialog(
    document.querySelector("#clear-shopping-list-dialog")
  );
});
const ids = reactive({
  shoppingListId: null,
});
function showModal({ shoppingListId, roomId }) {
  modal.value?.show();
  ids.shoppingListId = shoppingListId;
}
defineExpose({ showModal });

const store = useShoppingListStore();
async function onDelete() {
  await store.clearList({
    shoppingListId: ids.shoppingListId,
  });
  modal.value?.hide();
}
</script>

<style scoped lang="scss">
.delete-product {
  max-width: 460px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  gap: 70px;
  &__title {
    font-weight: 600;
    font-size: 2.5rem;
    text-align: center;
    max-width: 360px;
    color: #353535;
  }
  &__button-group {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 20px;
  }
  &__button {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    max-width: 220px;
    flex: 1;
    background: #498388;
    border: 1px solid #3b767b;
    border-radius: 6px;
    padding: 13px 0;
    font-weight: 600;
    font-size: 1.75rem;
    text-align: center;
    color: #ffffff;
    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
    &-outline {
      background-color: transparent;
      border: 2px solid #a2c0c2;
      border-radius: 6px;
      color: #498388;
    }
  }
}
</style>
